// R_ColorShiftLightingBytes: overbright light values scaled up by 2^shift,
// normalized by colour instead of saturating to white. No Three.js (map
// loading worker).

export function colorShift(src: ArrayLike<number>, srcOffset: number, dst: Uint8Array | number[], dstOffset: number, shift: number): void {
  const mul = 1 << shift;
  let r = src[srcOffset] * mul;
  let g = src[srcOffset + 1] * mul;
  let b = src[srcOffset + 2] * mul;
  const max = Math.max(r, g, b);
  if (max > 255) {
    const s = 255 / max;
    r *= s;
    g *= s;
    b *= s;
  }
  dst[dstOffset] = r;
  dst[dstOffset + 1] = g;
  dst[dstOffset + 2] = b;
}
